import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.OrderFileNaming.title',
    defaultMessage: 'File naming for this order only. The company convention is not changed.',
  },
  company: {
    id: 'containers.OrderPage.components.OverviewPage.OrderFileNaming.company',
    defaultMessage: 'Company ({preset})',
  },
  markers: {
    id: 'containers.OrderPage.components.OverviewPage.OrderFileNaming.markers',
    defaultMessage: 'Available markers',
  },
})
